import Moment from 'moment'
import Message from 'element-ui'

export function getCaption(obj, state, symbol) {
  var index = obj.lastIndexOf(symbol);
  if(state == 0){
    // 前
    obj = obj.substring(0,index);
  }else {
    // 后
    obj = obj.substring(index+1,obj.length);
  }
  return obj;
}

export function getUID() { // 获取唯一值
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
  });
}

export function checkType(type) {
  if (type == "RADIO") {
    return "单选题";
  } else if (type == "CHECKBOX") {
    return "多选题";
  } else if (type == "BOOLEAN") {
    return "判断题";
  } else if (type == "SUPPLY") {
    return "填空题";
  } else if (type == "ANSWER") {
    return "简答题";
  }
}

export function getArrayStatistic(array, field, type) {
  //中间数组,用来将对象数组内的指定属性，提取出来，重新建立一个数组
  const midArray = [];
  for (let i = 0; i < array.length; i++) {
    midArray.push(array[i][field]);
  }
  switch (type) {
    case "max": // 计算某一属性下的最大值
      return Math.max(...midArray);
    case "min": // 计算某一属性下的最小值
      return Math.min(...midArray);
    case "avg": // 计算某一属性的平均值
      var sumValue = 0;
      for (let i = 0; i < midArray.length; i++) {
        sumValue += Number(midArray[i]);
      }
      return Number((sumValue / midArray.length).toFixed(1));
    default:
      console.log("未知计算参数！");
  }
}

export function dateCount(times) {
  var d = parseInt(times / 60 / 60 / 24); // 天
  d = d < 10 ? '0' + d : d;
  var h = parseInt(times / 60 / 60 % 24); //时
  h = h < 10 ? '0' + h : h;
  var m = parseInt(times / 60 % 60); // 分
  m = m < 10 ? '0' + m : m;
  var s = parseInt(times % 60); // 当前的秒
  s = s < 10 ? '0' + s : s;
  if (d > 0) return d + '天' + h + '小时' + m + '分钟' + s + '秒';
  else if (d <= 0 && h > 0) return h + '小时' + m + '分钟' + s + '秒';
  else if (d <= 0 && h <= 0 && m > 0) return m + '分钟' + s + '秒'
  else return s + '秒'
}

export function handleTree(data, id = 'id', parentId = 'parentId', children = 'children', rootId = null) {
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  //循环所有项
  const treeData = cloneData.filter(father => {
    let branchArr = cloneData.filter(child => {
      //返回每一项的子级数组
      return father[id] === child[parentId]
    });
    branchArr.length > 0 ? father.children = branchArr : '';
    //返回第一层
    return father[parentId] === rootId;
  });
  return treeData != '' ? treeData : data;
}

/**
 * 格式化时间
 */
export function formatTime(timespan) {
  Moment.locale('zh-cn');
  return Moment(timespan).local().fromNow();
}

export const formatDate = function (date, fmt = "YYYY/MM/DD HH:mm:ss") {
  if (date) {
    return Moment(date).format(fmt);
  }
};

/**
 * 秒转化为hh:mm:ss格式
 */
export const formatSeconds = function (value) {
　let result = parseInt(value)
　let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
　let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
　let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
　result = `${h}:${m}:${s}`
　return result
}

/**
 * 不足两位补零
 */
export const formatNumber = function (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}


// 剩余时间
export const surplusTime = function (startTime, endTime) {
  if (new Date(startTime) == 'Invalid Date') {
    Message.error('开始时间不正确')
    return '';
  }
  if (new Date(endTime) == 'Invalid Date') {
    Message.error('结束时间不正确')
    return '';
  }
  let time = (new Date(endTime) - new Date(startTime)) / 1000;
  if (time <= 0) {
    return 0
  } else {
    if (time < 60) return `${time}秒`
    if (time < 3600) return ((a = parseInt(time / 60)) < 10 ? "0" + a : a) + "分钟";
    if (3600 <= time) {
      var a, e = parseInt(time / 3600);
      return (e < 10 ? "0" + e : e) + "小时" + ((a = parseInt(time % 3600 / 60)) < 10 ? "0" + a : a) + "分钟";
    }
  }
}

// 返回考试时间
export const testTime = function (nowTime, endTime) {
  if (new Date(nowTime) == 'Invalid Date') {
    Message.error('时间格式不正确')
    return '';
  }
  if (new Date(endTime) == 'Invalid Date') {
    Message.error('结束时间格式不正确')
    return '';
  }
  let time = (new Date(endTime) - new Date(nowTime)) / 1000;
  if (time <= 0) {
    return 0
  } else {
    return parseInt(time)
  }
}